import { Component, OnInit, ElementRef, Input, PLATFORM_ID, Inject, NgZone, HostListener, Renderer2, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { IPlayable, IMediaSubscriptions } from 'videogular2/src/core/vg-media/i-playable';
import { VgStates, VgEvents, VgAPI } from 'videogular2/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs';


declare let flashevents;

@Component({
  selector: 'vg-flash-media',
  templateUrl: './vg-flash.media.component.html',
  styleUrls: ['./vg-flash.media.style.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VgFlashMedia implements IPlayable {

  id: string;
  elem: any;
  time: any = { current: 0, total: 0, left: 0 };
  buffer: any;
  track?: any;
  canPlay: boolean = false;
  canPlayThrough: boolean = false;
  isMetadataLoaded: boolean = false;
  isWaiting: boolean = false;
  isCompleted: boolean = false;
  isLive: boolean = false;
  state: string = VgStates.VG_PAUSED;
  internal_state = '';
  is_paused: boolean = false;
  internal_position: number = -1;
  internal_volume: number = 1;
  textTracks: TextTrackList;
  subscriptions: IMediaSubscriptions;
  _duration: number;
  _currentTime: number;
  @Input() vgMaster: boolean;
  @Input() vgSkipSync: boolean = false;
  @Input() vgMedia: any;
  @Input() src: string;
  @Input() autoplay: boolean;
  @Input() poster: any;
  posterVisible:boolean = true;
  isClient: boolean = false;
  loadedData:boolean = false;

  flashObject: any;
  playbackRate = 1;
  flashParams: object;
  events;
  jsPingDate;
  flashPingDate; 
  jsLoadDate: Date; 
  flashLoadDate;
  lastSeekingIdx;
  lastFragPlayingIdx;
  
  flashSubscription: Subscription;
  flashApi: any;
  //seekNow: boolean = true;
  internal_buffered: Object = {
    length: 1,
    internal_end: 0,
    internal_start: 0,
    start: function(index) {
      return this.internal_start;
    },
    end: function(index) {
      return this.internal_end;
    }
  };



//   addTextTrack?: Function;
//   dispatchEvent?: Function;

  volumeChangeObs: Subscription;

  constructor(
    private ref: ElementRef,
    @Inject(PLATFORM_ID) private platformId: string,
    private cd : ChangeDetectorRef,
    private api: VgAPI,
  ) { 
    this.elem = ref.nativeElement;
  
    this.id = this.elem.id;
    this.isClient = isPlatformBrowser(this.platformId);
    
    if (this.isClient){
      flashevents.eventDispatcher.addEventListener("ready", this.flashLoad);
      flashevents.eventDispatcher.addEventListener("error", this.flashError);
      flashevents.eventDispatcher.addEventListener("manifestloaded", this.onFlashManifest);
      flashevents.eventDispatcher.addEventListener("statechanged", this.onStateChange);
      flashevents.eventDispatcher.addEventListener("timeupdate", this.onTimeUpdate);
      flashevents.eventDispatcher.addEventListener("complete", this.onComplete);
      flashevents.eventDispatcher.addEventListener("seeking", this.onSeeking);
      flashevents.eventDispatcher.addEventListener("seeked", this.onSeeked);
    }
  }

  onSeeking = (ev) => {
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_SEEKING));
  }

  onSeeked = (ev) => {
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_SEEKED));
  }

  onComplete = (ev) => {
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_ENDED));
    this.posterVisible = true;
  }

  onTimeUpdate = (ev) => {
    
    const metrics = ev.detail;

    if(!this.loadedData)
    {
      this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_LOADED_DATA));
      this.loadedData = true;
    }

    if(metrics.position != this._currentTime)
    {
      this._currentTime = metrics.position;
      this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_TIME_UPDATE));
    }
    
    if (metrics.duration && this._duration != metrics.duration){
      this._duration = metrics.duration;
      this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_DURATION_CHANGE));      
    }

    this.internal_buffered['internal_start'] = parseFloat(metrics.position) - parseFloat(metrics.backbuffer);
    this.internal_buffered['internal_end'] =  parseFloat(metrics.position) + parseFloat(metrics.buffer);

    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PROGRESS));

    if((parseFloat(metrics.position) + parseFloat(metrics.buffer)) > parseFloat(metrics.duration))
    {
      this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_CAN_PLAY_THROUGH));
    }
  }

  onStateChange = (ev) => {
    this.internal_state = ev.detail.type;
  }

  flashLoad = (ev) => {
    this.flashApi = flashevents.api;
    this.load();
  }

  flashError = (ev) => {
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_ERROR));
  }

  onFlashManifest = (ev) => {
    this._currentTime = 0;
    this._duration = ev.detail.totalDuration;
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_LOADED_METADATA));
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_CAN_PLAY));
  }



  ngOnInit() {
    this.api.registerMedia(this);
  }


  ngOnDestroy(){
    if (this.isClient){
      flashevents.eventDispatcher.removeEventListener("ready", this.flashLoad);
      flashevents.eventDispatcher.removeEventListener("error", this.flashError);
      flashevents.eventDispatcher.removeEventListener("manifestloaded", this.onFlashManifest);
      flashevents.eventDispatcher.removeEventListener("statechanged", this.onStateChange);
      flashevents.eventDispatcher.removeEventListener("timeupdate", this.onTimeUpdate);
      flashevents.eventDispatcher.removeEventListener("complete", this.onComplete);
      flashevents.eventDispatcher.removeEventListener("seeking", this.onSeeking);
      flashevents.eventDispatcher.removeEventListener("seeked", this.onSeeked);
    }
  }

  ngAfterViewInit(){
    let movie:any = flashevents.getFlashMovieObject("moviename");

       if(!movie || !movie.Movie || movie.Movie == "")
       {
        movie.WMode = "Opaque";
        movie.BGColor = "#000";
        movie.FlashVars = "callback=flashevents.flashlsCallback";
        movie.Movie = "/js/flashlsChromeless.swf?inline=1";
       }
  }

  set currentTime(seconds) {
    this.seekTime(seconds);
}

  get currentTime() {
      return this._currentTime;
  }


  load(){
    //this.flashApi.stop();
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_LOAD_START));
    
    if(this.src.indexOf("https") == -1)
      this.flashApi.load('https:' + this.src);
    else
      this.flashApi.load(this.src);
  }

  seekTime(pos){
    this.flashApi.seek(pos);
  }

  get buffered() {
    return this.internal_buffered;
  }

  get duration(){
    return this._duration;
  }

  play(){

    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PLAY));
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PLAYING));

    this.internal_state = "playing";
    this.posterVisible = false;

    if(!this.is_paused){
      this.flashApi.play(-1);
    }
    else{
      this.flashApi.resume();
    }
    this.is_paused = false;
  }

  pause(){
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PAUSE));
    this.is_paused = true;
    this.flashApi.pause(this.flashObject);
  }



  set volume(volume) {
    this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_VOLUME_CHANGE));
    this.internal_volume = volume;
    this.flashApi.volume(volume * 100);
  }

  get volume() {
    return this.internal_volume;
  }

  dispatchCustomEvents(state){
    if (state == 'PLAYING'){
      this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_PLAYING));
      return;
    }
    if (state == 'SEEKED'){
      this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_SEEKED));
      return;
    }
    if (state == 'SEEKING'){
      this.elem.dispatchEvent(new CustomEvent(VgEvents.VG_SEEKING));
      return;
    }    
  }

  
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/flash-hls-fallback/vg-flash.media/vg-flash.media.component.ts